export const theme = {
  colors: {
    primaryOrange: `#F4C343`,
    secondaryOrange: `rgba(244, 195, 67, 0.8)`,
    whiteText: '#F8F8F8',
    primaryBlackText: '#252525',
    secondaryBlackText: `#373737`,
    yellowText: '#ECC747',
    footerText: '#F5F5F5',
    grey: '#A2A8BC',
    bgGrey: 'rgba(217, 217, 217, 0.15);',
    white: '#FFFFFF',
    bgFooter: 'rgba(25, 25, 25, 0.5)',
    bgFooterBlack: 'rgba(25, 25, 25, 1)',
    bgModal: '#FDFDFD',
    error: '#FF6767',
    shoppingGrey: '#EDEDED',
  },
};
